import * as React from 'react';
import CalendarSurfaceStore from '../store/schema/CalendarSurfaceStore';
import ColumnPastDayHighlightBehavior from '../logic/behaviors/column/ColumnPastDayHighlightBehavior';
import convertLayoutPositionToFlexStyles from '../utils/convertLayoutPositionToFlexStyles';
import { attachBehaviors } from 'owa-calendar-surface-core';
import { CalendarSurfaceTransformProps } from '../interfaces/CalendarSurfaceTransformProps';
import { ColumnProvider } from '../interfaces/ColumnProvider';
import { createDateColumnHeader } from '../Templates';
import { getColumnRangeHorizontalLayout } from '../logic/getColumnRangeHorizontalLayout';
import { GridLines } from '../surfaceItems/GridLines';
import { OwaDate } from 'owa-datetime';

/**
 * Creates surface grid lines
 * @param store The surface store
 * @param config The config
 */
export function createGridLines(
    store: CalendarSurfaceStore,
    config: CalendarSurfaceTransformProps
) {
    const itemsLayout = config.itemsLayout;
    const increment = store.userOptions.hourIncrement;

    return <GridLines store={store} itemsLayout={itemsLayout} increment={increment} />;
}

/**
 * Creates surface date headers
 * @param store The surface store
 * @param config The config
 */
export function createHeaders(
    store: CalendarSurfaceStore,
    config: CalendarSurfaceTransformProps,
    hideHeaderAddOns: boolean = false,
    calendarFolderId?: string
) {
    return createDatesColumnHeaders(
        config.columnProvider.columnModels,
        config.columnProvider,
        hideHeaderAddOns ? null : config.renderDateHeaderAddOn,
        config.onSurfaceClick,
        config.disablePastDayHighlight,
        calendarFolderId
    );
}

function createDatesColumnHeaders(
    dates: OwaDate[],
    columnProvider: ColumnProvider,
    renderDateHeaderAddOn?: (date: OwaDate) => JSX.Element,
    onSurfaceClick?: (
        start: OwaDate,
        end: OwaDate,
        isAllDay: boolean,
        props?: any,
        selectedCalendarId?: string
    ) => void,
    disablePastDayHighlight?: () => boolean,
    calendarFolderId?: string
) {
    return dates.map((date, key) => {
        const columnIndex = columnProvider.getColumnIndex(date);
        let layout = getColumnRangeHorizontalLayout(columnIndex, columnIndex + 1, columnProvider);
        let style = convertLayoutPositionToFlexStyles(layout);

        let behaviors = [];
        if (disablePastDayHighlight && !disablePastDayHighlight()) {
            behaviors.push(<ColumnPastDayHighlightBehavior date={date} />);
        }

        return attachBehaviors(
            createDateColumnHeader(
                date,
                key,
                style,
                renderDateHeaderAddOn,
                onSurfaceClick,
                calendarFolderId
            ),
            behaviors
        );
    });
}
